export default {
	common: {
		searchForm: {
			query: 'Query',
			reset: 'Reset'
		},
		tableCom: {
			noData: 'No Data',
			total: 'Total',
			page: 'Page',
			pageSize: 'Items per page',
			confirm: 'Confirm',
			cancel: 'Cancel',
			action: 'Action',
			view: 'View',
			edit: 'Edit',
			delete: 'Delete',
			batchDelete: 'Batch Delete',
			upload: 'Upload',
			download: 'Download',
			preview: 'Preview',
			pleaseSelect: 'Please Select',
			operationSuccess: 'Operation Successful',
			operationFailed: 'Operation Failed',
			loading: 'Loading...',
			required: 'This field is required'
		},
		onlinePreview: {
			preview: 'Preview',
			notSupport: 'File type not supported for preview'
		},
		attachmentList: {
			title: 'Attachment List',
			upload: 'Upload File',
			download: 'Download',
			delete: 'Delete',
			preview: 'Preview',
			uploadSuccess: 'Upload Successful',
			uploadFailed: 'Upload Failed',
			deleteSuccess: 'Delete Successful',
			deleteFailed: 'Delete Failed',
			confirmDelete: 'Are you sure to delete this file?',
			fileTooLarge: 'File size cannot exceed {size}MB',
			onlyOneFile: 'Only one file allowed',
			maxFiles: 'Maximum {max} files'
		},
		detailDialog: {
			detail: 'Details',
			close: 'Close',
			noFiles: 'No files',
			unnamedFile: 'Unnamed file'
		},
		startStopRecord: {
			timeline: 'Device Start-Stop Timeline',
			deviceName: 'Device Name',
			deviceNo: 'Device Number',
			status: 'Status',
			startTime: 'Start Time',
			endTime: 'End Time',
			checkProject: 'Check Item',
			checkMethod: 'Check Method',
			runTime: 'Running Time',
			stopTime: 'Stop Time',
			dateRangePlaceholder: 'Select Date Range',
			running: 'Running',
			stopped: 'Stopped'
		}
	},
	passwordForm: {
		oldPassword: 'Old Password',
		newPassword: 'New Password',
		confirmPassword: 'Confirm Password',
		oldPasswordPlaceholder: 'Please enter old password',
		newPasswordPlaceholder: 'Please enter new password',
		confirmPasswordPlaceholder: 'Please enter confirm password',
		required: '{field} is required',
		passwordNotMatch: 'Passwords do not match',
		passwordLength: 'Password length must be between {min} and {max} characters',
		submit: 'Submit',
		reset: 'Reset'
	},
	appDownload: {
		title: 'Mobile APP Download',
		qrcodeTip: 'Scan QR code to download APP',
		manualTitle: 'Operation Manual',
		manualPreview: 'Operation Manual'
	},
	aiAssistant: {
		title: 'AI Assistant',
		history: 'History',
		newChat: 'New Chat',
		noMoreHistory: 'No more history',
		noHistory: 'No history',
		loading: 'Loading...',
		selectModel: 'Select Model',
		resetChat: 'Reset Chat',
		recommendedQuestions: 'Recommended Questions',
		thinking: 'Thinking...',
		inputPlaceholder: 'Enter your question...',
		welcomeMessage: "Hello! I'm your AI assistant, how can I help you?",
		question1: 'How to quickly locate the cause of device abnormal alarm?',
		question2: 'How to formulate an effective device preventive maintenance plan?',
		question3: 'How to troubleshoot device data collection anomalies?',
		question4: 'How to optimize device operation efficiency?',
		question5: 'How to determine the device maintenance cycle?',
		yesterday: 'Yesterday',
		daysAgo: '{days} days ago',
		connectionError: 'Connection failed, please check network',
		connectionErrorMessage: 'Connection failed, please check network.'
	},
	printQrcode: {
		size: 'Size',
		color: 'Color',
		qrcode: 'QR Code',
		print: 'Print',
		download: 'Download Image'
	},
	lazyImage: {
		loading: 'Loading...'
	},
	performance: {
		loadTime: 'Page Load Time',
		domReady: 'DOM Ready',
		fcp: 'First Contentful Paint',
		lcp: 'Largest Contentful Paint',
		fid: 'First Input Delay',
		cls: 'Cumulative Layout Shift'
	},
	charts: {
		noData: 'No Data',
		emptyState: {
			noDataTitle: 'No data collected in current period',
			noDataDesc: 'Please select another time period or check data collection status',
			loadErrorTitle: 'Data loading failed',
			loadErrorDesc: 'Please refresh and try again',
			networkErrorTitle: 'Network connection error',
			networkErrorDesc: 'Please check network and try again'
		},
		peakCount: {
			title: 'Peak Spectrum Table',
			index: 'Index',
			frequency: 'Frequency (Hz)',
			amplitude: 'Amplitude'
		},
		rotFre: {
			title: 'Rotation Speed Analysis',
			basic: 'Basic Settings',
			speed: 'Rotation Speed (r/min):',
			base: 'Rotation (Hz):',
			count: 'Multiplier Count:',
			preview: 'Rotation Speed Multiplier Preview',
			tip: 'Marker lines will be drawn at integer multiples of the rotation frequency corresponding to the rotation speed. Click the tool again to close',
			baseRequired: 'Please enter a rotation speed greater than 0'
		},
		highChart: {
			delete: 'Delete',
			peakFind: 'Peak Find',
			screenshot: 'Screenshot',
			setModel: 'Set Model',
			setFreCount: 'Set Frequency Band Count',
			setMarkPoint: 'Set Mark Point',
			deletePoint: 'Delete Mark Point',
			setCharFre: 'Set Characteristic Frequency',
			setPeakCount: 'Set Peak Count',
			setAbnormal: 'Set Abnormal Remark',
			singleMarkPointMode: 'Single Mark Point Mode',
			singleMarkPointModeClose: 'Single Mark Point Mode Closed',
			freCountSet: 'Frequency band count set to {count}',
			modelAnnotateSuccess: 'Annotation successful',
			downloadSuccess: 'Download successful',
			screenshotSaveSuccess: 'Screenshot saved successfully',
			screenshotFailed: 'Screenshot failed',
			abnormalRemarkSaved: 'Abnormal remark saved',
			alreadyMarked: 'This node has already been marked, please select another node',
			baseline: 'Baseline',
			auxiliaryLine: 'Auxiliary Line',
			peak: 'Peak',
			freSideInterval: 'Sideband Interval',
			rotFreLabel: 'Rotation Speed',
			noDataCollected: 'No data collected in current period',
			noDataDesc: 'Please select another time period or check data collection status',
			dataLoadFailed: 'Data loading failed',
			dataLoadFailedDesc: 'Please try again later or contact administrator',
			networkError: 'Network connection error',
			networkErrorDesc: 'Please check network connection and try again'
		}
	},
	dateRange: {
		to: 'to',
		startDate: 'Start Date',
		endDate: 'End Date'
	},
	maReport: {
		title: 'Report Selection',
		fileName: 'Report Name',
		deviceName: 'Device Name',
		createTime: 'Create Time'
	},
	deviceModelLibrary: {
		configDeviceModel: 'Configure Device Model',
		selectDeviceType: 'Please select device type',
		addModelImage: 'Add Model Image',
		editModelImage: 'Edit Model Image'
	},
	devicePlm: {
		deviceBasicInfo: 'Device Basic Information',
		editDeviceBasicInfo: 'Edit Device Basic Information'
	},
	maOrg: {
		selectOrg: 'Organization Selection',
		name: 'Name',
		parentName: 'Parent Name'
	},
	maOrgTree: {
		placeholder: 'Enter keywords to filter',
		expandAll: 'Expand All',
		collapseAll: 'Collapse All'
	},
	generateForm: {
		addDetail: 'Add Detail',
		clickUpload: 'Click to Upload',
		fileUploadSuccess: 'File uploaded successfully',
		fileUploadTimeout: 'File upload timed out, please re-upload',
		fileInfoIncomplete: 'File information is incomplete, unable to delete',
		fileDeleteSuccess: 'File deleted successfully',
		fileDeleteFailed: 'File deletion failed',
		fileDeleteRequestFailed: 'File deletion request failed',
		exceedUploadLimit: 'Exceeded upload limit',
		operation: 'Action',
		delete: 'Delete'
	},
	maDevice: {
		selectDevice: 'Device Selection',
		deviceId: 'Device ID',
		deviceName: 'Device Name',
		number: 'Number',
		location: 'Location',
		department: 'Department',
		keyType: 'Criticality'
	},
	maRole: {
		selectRole: 'Role Selection',
		name: 'Name',
		code: 'Code',
		remark: 'Remark'
	},
	maPost: {
		selectPost: 'Position Selection',
		postCode: 'Position Code',
		postName: 'Position Name'
	},
	maInspectDevice: {
		selectDevice: 'Device Selection',
		deviceId: 'Device ID',
		deviceName: 'Device Name',
		department: 'Department'
	},
	maOrgInspect: {
		selectOrg: 'Organization Selection',
		name: 'Name',
		parentName: 'Parent Name'
	},
	maDianjian: {
		title: 'Inspection Items',
		projectId: 'Project ID',
		projectName: 'Inspection Item',
		method: 'Inspection Method'
	},
	hooks: {
		action: 'Action',
		confirm: 'Confirm',
		cancel: 'Cancel',
		deleteConfirm: 'Are you sure you want to delete?',
		deleteSuccess: 'Delete successful',
		selectDeleteWarning: 'Please select records to delete',
		downloadSuccess: 'Download successful'
	},
	zyForm: {
		confirm: 'Confirm',
		cancel: 'Cancel',
		validationFailed: 'Validation failed!',
		requiredField: '{field} is required!'
	},
	maUpload: {
		upload: 'Upload',
		uploading: 'Uploading',
		success: 'Upload successful',
		fail: 'Upload failed',
		image: {
			edit: 'Edit',
			view: 'View',
			delete: 'Delete'
		}
	}
}
